module.exports = __webpack_public_path__ + "static/media/044.1f26c778.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/044.wav
 ** module id = 176
 ** module chunks = 0
 **/